/**
 * Application Routes
 * Defines all application routes and navigation structure
 */

import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from '../features/auth/AuthProvider';
import { LoginPage } from './login';
import { CallbackPage } from './callback';
import { SpotifyErrorPage } from './spotify-error';
import { InvitationRequiredPage } from './invitation-required';
import { AppLayout } from './app/layout';
import { WorkbenchPage } from './app/index';
import { CatalogsPage } from './app/catalogs';
import { SequencesPage } from './app/sequences';
import { SettingsPage } from './app/settings';
import { ToastContainer } from '../components/ui/Toast';

/**
 * Root redirect - sends to /app if authenticated, /login otherwise
 */
function RootRedirect() {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="min-h-screen bg-gray-900 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#1DB954] mx-auto mb-4"></div>
          <p className="text-gray-300">Loading...</p>
        </div>
      </div>
    );
  }

  return <Navigate to={isAuthenticated ? '/app' : '/login'} replace />;
}

export default function AppRoutes() {
  return (
    <>
      <Routes>
        {/* Root redirect */}
        <Route path="/" element={<RootRedirect />} />

        {/* Public routes */}
        <Route path="/login" element={<LoginPage />} />
        <Route path="/callback" element={<CallbackPage />} />
        <Route path="/spotify-error" element={<SpotifyErrorPage />} />
        <Route path="/invitation-required" element={<InvitationRequiredPage />} />

        {/* Protected routes */}
        <Route path="/app" element={<AppLayout />}>
          <Route index element={<WorkbenchPage />} />
          <Route path="catalogs" element={<CatalogsPage />} />
          <Route path="sequences" element={<SequencesPage />} />
          <Route path="settings" element={<SettingsPage />} />
        </Route>

        {/* 404 fallback */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>

      {/* Global toast notifications */}
      <ToastContainer />
    </>
  );
}
